import React, { useEffect, useRef, useState } from "react";
import { FiInfo } from "react-icons/fi";
import { onAgtError, regulatoyinfo } from "../components/CommonFun";
import { GetApi } from "../api/api-service";
import { API_Path, imgBaseUrl } from "../Const";
import { Link, useNavigate, useParams } from "react-router";
import EmailAgentModal from "../components/modal/EmailAgentModal";
import ContectModal from "../components/modal/ContectModal";
import AgentContectModal from "../components/modal/AgentContectModal";
import TruAgentModal from "../components/modal/TruAgentModal";
import QualityLister from "../components/modal/QualityLister";
import ResponsiveBrokerModal from "../components/modal/ResponsiveBrokerModal";
import qualityListings from "../images/agent/QualityListings.svg";
import badgeResponsive from "../images/agent/BadgeResponsive.svg";
import PropertySection from "../components/property/PropertySection";
import SpinnerLoader from "../components/loader/SpinnerLoader";
import CommonPagination from "../components/CommonPagination";
import useTooltipPosition from "../components/CustomizedHook/updatePosition";
import noProperty from "../images/no-property-found.png";
import NewCommonPagination from "../components/NewCommonPagination";
import PropertiesLoader from "../components/loader/PropertiesLoader";
import AgentLoader from "../components/loader/AgentLoader";
import { RiMedal2Fill } from "react-icons/ri";
import { BsFillShareFill } from "react-icons/bs";
import dummyPerson from "../images/dummy_person.png";
import developerLogo from "../images/developer.svg";
import { REMail, RETelephone, REWhatsapp } from "../components/icons/IconSvg";
import SocialShareModal from "../components/modal/SocialShareModal";

var linkURL;
function AgenciesDetails() {
    const navigate = useNavigate();
    const serviceAreasRef = useRef();
    const descriptionRef = useRef();
    const { wrapperRef, tooltipRef, position, updatePosition } = useTooltipPosition();
    const [propertyTab, setPropertyTab] = useState("activeListings");
    const [agencyData, setAgencyData] = useState({});
    const [agentdata, setAgentData] = useState([]);
    const [propertyData, setPropertyData] = useState([]);
    const [isLoader, setIsLoader] = useState(false);
    const [isLoaders, setIsLoaders] = useState({ isAgent: false, isProperty: false });
    const [emailModalShow, setEmailModalShow] = useState(false);
    const [phoneModalShow, setPhoneModalShow] = useState({ show: false, data: {} });
    const [agentContectMdl, setAgentContectMdl] = useState({ show: false, data: {} });
    const [auth, setAuth] = useState();
    const [qualityShow, setQualityShow] = useState(false);
    const [truAgentShow, setTruAgentShow] = useState(false);
    const [resAgentShow, setResAgentShow] = useState(false);
    const [paginations, setPaginations] = useState({ currentPage: 1, pageSize: 24, totalPages: 1, countData: 0 });
    const [aPaginations, setAPaginations] = useState({ currentPage: 1, pageSize: 10, totalPages: 1, countData: 0 });
    const [isExpanded, setIsExpanded] = useState({ serviceAreas: false, description: false });
    const [maxHeight, setMaxHeight] = useState({ serviceAreas: "76px", description: "76px" });
    const [shouldShowButton, setShouldShowButton] = useState({ serviceAreas: false, description: false });
    const [socialShare, setSocialShare] = useState({ show: false, data: "", name: "" });

    const handleTab = (name) => {
        setPropertyTab(name);
    };

    const toggleExpanded = (key) => {
        const ref = key === "serviceAreas" ? serviceAreasRef : descriptionRef;
        setIsExpanded((prev) => {
            const newState = !prev[key];
            setMaxHeight((prevMax) => ({
                ...prevMax,
                [key]: newState ? `${ref.current.scrollHeight}px` : "76px",
            }));
            return { ...prev, [key]: newState };
        });
    };

    useEffect(() => {
        const checkOverflow = () => {
            if (agencyData?.serviceAreas && serviceAreasRef.current) {
                setShouldShowButton((prev) => ({
                    ...prev,
                    serviceAreas: serviceAreasRef.current.scrollHeight > 76,
                }));
                setMaxHeight((prevMax) => ({
                    ...prevMax,
                    serviceAreas: serviceAreasRef.current.scrollHeight <= 76 ? `${serviceAreasRef.current.scrollHeight}px` : "76px",
                }));
            }
            if (agencyData?.description && descriptionRef.current) {
                setShouldShowButton((prev) => ({
                    ...prev,
                    description: descriptionRef.current.scrollHeight > 76,
                }));
                setMaxHeight((prevMax) => ({
                    ...prevMax,
                    description: descriptionRef.current.scrollHeight <= 76 ? `${descriptionRef.current.scrollHeight}px` : "76px",
                }));
            }
        };
        checkOverflow();
    }, [agencyData?.serviceAreas, agencyData?.description]);

    var verSecParam = useParams();
    useEffect(() => {
        if (verSecParam["*"] === "agents") {
            setPropertyTab("agents");
        } else {
            if (propertyData.length > 0) setPropertyTab("activeListings");
            else if (agentdata.length > 0) setPropertyTab("agents");
        }
    }, [agentdata, propertyData]);

    useEffect(() => {
        if (verSecParam.id !== null && verSecParam.id !== undefined && verSecParam.id !== "") {
            let data = verSecParam?.id.split("_", 2)[1] ?? verSecParam?.id;
            fetchAgenciesDetails(data);
            fetchAgentToAgency(data, 1);
            fetchPropertyToAgency(data, 1);
            linkURL = data;
        } else navigate("/");
    }, []);

    const fetchAgenciesDetails = async (id) => {
        try {
            setIsLoader(true);
            let res = await GetApi(API_Path.AgenciesDetails + `/${id}`);
            if (res && res.data.success) {
                setAgencyData(res.data.data);
                let authoritiesData = res.data.data?.authorities;
                let margeData = authoritiesData.map((authority) => {
                    const regulatory = regulatoyinfo.find((info) => info.authorityType.toLowerCase() === authority.authorityType.toLowerCase());
                    if (regulatory) {
                        return {
                            ...authority,
                            fullName: regulatory.fullName,
                            tooltip: regulatory.tooltip,
                            isActive: regulatory.isActive,
                        };
                    }
                    return authority;
                });
                let data = transformAuthorities(margeData);
                setAuth(data);
            }
            setIsLoader(false);
        } catch (error) {
            setIsLoader(false);
        }
    };
    const fetchAgentToAgency = async (id, page) => {
        try {
            setIsLoaders((prevMax) => ({ ...prevMax, isAgent: true }));
            let res = await GetApi(API_Path.AgentByAgency + `${id}?pageNumber=${page}&pageSize=${aPaginations?.pageSize}`);
            if (res && res.data.success) {
                let page = res.data;
                setAgentData(page.data);
                setAPaginations({ currentPage: page?.currentPage, pageSize: page?.pageSize, totalPages: page?.totalPages, countData: page?.totalRecords });
            }
            setIsLoaders((prevMax) => ({ ...prevMax, isAgent: false }));
        } catch (error) {
            setIsLoaders((prevMax) => ({ ...prevMax, isAgent: false }));
        }
    };
    const fetchPropertyToAgency = async (id, page) => {
        try {
            setIsLoaders((prevMax) => ({ ...prevMax, isProperty: true }));
            let res = await GetApi(API_Path.propertyByAgency + `${id}?pageNumber=${page}&pageSize=${paginations?.pageSize}`);
            if (res && res.data.success) {
                let page = res.data;
                setPropertyData(page.data);
                setPaginations({ currentPage: page?.currentPage, pageSize: page?.pageSize, totalPages: page?.totalPages, countData: page?.totalRecords });
            }
            setIsLoaders((prevMax) => ({ ...prevMax, isProperty: false }));
        } catch (error) {
            setIsLoaders((prevMax) => ({ ...prevMax, isProperty: false }));
        }
    };
    const transformAuthorities = (authorities) => {
        return authorities.reduce((result, { authorityType, authorityNumber, tooltip }) => {
            const existing = result.find((item) => item.authorityType === authorityType);
            if (existing) {
                existing.authorityNumber += `, ${authorityNumber}`;
            } else {
                result.push({
                    authorityType,
                    authorityNumber: authorityNumber.toString(),
                    tooltip: tooltip,
                });
            }
            return result;
        }, []);
    };

    const handlewhatsapp = (e) => {
        e.stopPropagation();
        e.preventDefault();
        window.open("https://web.whatsapp.com");
    };

    const handleModalHide = () => setEmailModalShow(false);
    const handlePhoneModalHide = () => setPhoneModalShow({ data: {}, show: false, agencyNumber: "" });
    const handleAgentContectMDlHide = () => setAgentContectMdl({ data: {}, show: false, agencyNumber: "" });
    const handleSocialShareClose = () => setSocialShare({ show: false, data: "", name: "" });

    const handleTruAgentShow = (e) => {
        e.stopPropagation();
        e.preventDefault();
        setTruAgentShow(true);
    };
    const handleQualityShow = (e) => {
        e.stopPropagation();
        e.preventDefault();
        setQualityShow(true);
    };
    const handleResAgentShow = (e) => {
        e.stopPropagation();
        e.preventDefault();
        setResAgentShow(true);
    };
    const handleTruAgentClose = () => setTruAgentShow(false);
    const handleQualityClose = () => setQualityShow(false);
    const handleResAgentClose = () => setResAgentShow(false);
    const tableCallBack = (page) => fetchPropertyToAgency(linkURL, page);

    const tableCallBackAgent = (page) => {
        setPropertyTab("agents");
        window.scrollTo(0, 0);
        fetchAgentToAgency(linkURL, page);
    };

    let data = `/agencies/${verSecParam.id}/agents?`;

    const queryParams = `/agencies/${verSecParam.id}`;

    const loaders = Array.from({ length: 6 });
    return (
        <>
            <div className="agencies-sec">
                <div className="container">
                    <div className="agemcies-details">
                        <div className="agencies_details_inner">
                            <img
                                src={agencyData?.logoPath && agencyData?.logoPath !== "" ? `${imgBaseUrl}/${agencyData?.logoPath}` : developerLogo}
                                alt={agencyData?.name}
                                loading="lazy"
                                onError={({ currentTarget }) => {
                                    currentTarget.onerror = null;
                                    currentTarget.src = `${developerLogo}`;
                                }}
                            />
                        </div>
                        <div className="agencies-name">
                            {agencyData?.name && <h1>{agencyData?.name}</h1>}
                            <div className="broker_listings">
                                {agencyData?.agencyStats?.propertyCount && (
                                    <p>
                                        Properties - <b>{agencyData?.agencyStats?.propertyCount || 0}</b>
                                    </p>
                                )}
                                {paginations?.countData > 0 && (
                                    <p>
                                        Agent - <b>{paginations?.countData}</b>
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="agencies-tab-sec">
                <div className="container">
                    <div className="agencies-tab-inner">
                        <div className="tab-panel">
                            <div className="tab-container">
                                <div className="agencies-tab-btn">
                                    <div className="tab-buttons">
                                        {propertyData && (
                                            <Link to={`/agencies/${agencyData?.slug}_${agencyData.uId}`} className={`tab-btn${propertyTab === "activeListings" ? " active" : ""}`} onClick={() => handleTab("activeListings")}>
                                                Active listings
                                            </Link>
                                        )}
                                        {agentdata.length > 0 && (
                                            <Link to={`/agencies/${agencyData?.slug}_${agencyData.uId}/agents?page=${aPaginations?.currentPage}`} className={`tab-btn${propertyTab === "agents" ? " active" : ""}`} onClick={() => handleTab("agents")}>
                                                Agents
                                            </Link>
                                        )}
                                    </div>
                                    <div className="agent-actions">
                                        {agencyData?.contactMethods?.email && (
                                            <div className="agent-actions-btn" onClick={() => setEmailModalShow(true)}>
                                                <REMail />
                                                <button className="email-btn">Email</button>
                                            </div>
                                        )}
                                        {agencyData?.contactMethods?.call && (
                                            <div className="agent-actions-btn" onClick={() => setPhoneModalShow({ ...phoneModalShow, show: true, data: agencyData })}>
                                                <RETelephone />
                                                <button className="call-btn">Call</button>
                                            </div>
                                        )}
                                        <div className="agent-actions-btn">
                                            <button type="button" onClick={() => setSocialShare({ show: true, data: `${agencyData.slug}_${agencyData?.uId}`, name: data?.properties?.title })}>
                                                <BsFillShareFill className="me-1" />
                                                Share a Profile
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div className="tab-content">
                                    <div className={`tab-panel`}>
                                        <div className="agencies-info">
                                            <div className={`agencies-info-wrapper${propertyData.length == 0 && agentdata.length == 0 ? " align-items-center" : ""}`}>
                                                <div className={`agencies-info-inner-left ${propertyTab === "activeListings" ? "active" : "d-none"}`}>
                                                    {isLoaders?.isProperty ? (
                                                        <div className="row slider-section info-block ">
                                                            {loaders.map((_, index) => (
                                                                <div className="info-block-inner info-block-agent" key={index}>
                                                                    <PropertiesLoader />
                                                                </div>
                                                            ))}
                                                        </div>
                                                    ) : (
                                                        <>
                                                            {propertyData.length > 0 ? (
                                                                <>
                                                                    <PropertySection ltsProperties={propertyData} name="agent" agentId={propertyData.agents} />
                                                                    <CommonPagination currentPage={paginations.currentPage} pageSize={paginations.pageSize} totalPages={paginations.totalPages} tableCallBack={tableCallBack} />
                                                                </>
                                                            ) : (
                                                                <div className="text-center">
                                                                    <img src={noProperty} alt="Currently, there are no active listings" />
                                                                    <h2 className="agencies_title mt-4">Currently, there are no active listings</h2>
                                                                </div>
                                                            )}
                                                        </>
                                                    )}
                                                </div>
                                                <div className={`agencies-info-inner-left ${propertyTab === "agents" ? "active" : "d-none"}`}>
                                                    {isLoaders?.isAgent ? (
                                                        <>
                                                            {loaders.map((_, index) => (
                                                                <div className="" key={index}>
                                                                    <AgentLoader />
                                                                </div>
                                                            ))}
                                                        </>
                                                    ) : (
                                                        agentdata.length > 0 && (
                                                            <>
                                                                {agentdata.map((data, i) => (
                                                                    <Link to={`/agent-details/${data?.slug}_${data?.uId}`} key={i}>
                                                                        <div className="agencies-preview">
                                                                            <div className="agent-preview-image">
                                                                                <img src={data.path ? `${imgBaseUrl}/${data.path}` : dummyPerson} alt={data.name ? `${data.name}'s profile picture` : "Agent profile"} loading="lazy" onError={onAgtError} />
                                                                            </div>
                                                                            <div className="agent_card_content agent_title">
                                                                                <h1 className="agent_name">{data?.name}</h1>
                                                                                <div className="top_agent">
                                                                                    {data?.isTopAgent && (
                                                                                        <div>
                                                                                            <button className="tru_btn" onClick={(e) => handleTruAgentShow(e)}>
                                                                                                <RiMedal2Fill color="#28b16d" />
                                                                                                Tru<b>Agent</b>
                                                                                                <span>™</span>
                                                                                            </button>
                                                                                        </div>
                                                                                    )}
                                                                                    {data?.isQualityLister && (
                                                                                        <div>
                                                                                            <button className="tru_btn lister_btn" onClick={(e) => handleQualityShow(e)}>
                                                                                                <div>
                                                                                                    <img src={qualityListings} alt="Quality Lister" />
                                                                                                </div>
                                                                                                <b>Quality Lister</b>
                                                                                            </button>
                                                                                        </div>
                                                                                    )}
                                                                                    {data?.isHighlyResponsive && (
                                                                                        <div>
                                                                                            <button className="tru_btn res_btn" onClick={(e) => handleResAgentShow(e)}>
                                                                                                <div>
                                                                                                    <img src={badgeResponsive} alt="Responsive Broker" />
                                                                                                </div>
                                                                                                <b>Responsive Broker</b>
                                                                                            </button>
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                                <div className="agent-details">
                                                                                    <p>Properties : </p>
                                                                                    <span>{data?.agentStats?.propertyCount ? data?.agentStats?.propertyCount : 0}</span>
                                                                                </div>
                                                                                {data?.agentLanguages.length <= 0 && data.languages && (
                                                                                    <div className="agent-details">
                                                                                        <p>Language : </p>
                                                                                        <span className="text-capitalize">{data.languages}</span>
                                                                                    </div>
                                                                                )}
                                                                                {data?.agentLanguages && data?.agentLanguages.length > 0 && (
                                                                                    <div className="agent-details">
                                                                                        <p>Language : </p>
                                                                                        <span className="text-capitalize">
                                                                                            {data?.agentLanguages
                                                                                                .map((data) => data.languageType)
                                                                                                .join(", ")
                                                                                                .replace(/, ([^,]*)$/, " & $1")}
                                                                                        </span>
                                                                                    </div>
                                                                                )}
                                                                                <div className="agent-actions details-btn">
                                                                                    {data?.contactMethods?.email && (
                                                                                        <button
                                                                                            className="button primary_button py-2 px-3"
                                                                                            onClick={(e) => {
                                                                                                e.stopPropagation();
                                                                                                e.preventDefault();
                                                                                                setEmailModalShow(true);
                                                                                            }}
                                                                                        >
                                                                                            <REMail />
                                                                                            Email
                                                                                        </button>
                                                                                    )}
                                                                                    {data?.contactMethods?.call && (
                                                                                        <button
                                                                                            className="button primary_button py-2 px-3"
                                                                                            onClick={(e) => {
                                                                                                e.stopPropagation();
                                                                                                e.preventDefault();
                                                                                                setAgentContectMdl({ show: true, data: data });
                                                                                            }}
                                                                                        >
                                                                                            <RETelephone />
                                                                                            Call
                                                                                        </button>
                                                                                    )}
                                                                                    {data?.contactMethods?.whatsApp && (
                                                                                        <div className="wp-btn">

                                                                                        <button className="button" onClick={handlewhatsapp} aria-label="Whatsapp">
                                                                                            <REWhatsapp />
                                                                                            WhatsApp
                                                                                        </button>
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                                <div>{data?.rating && data?.rating !== 0 && <div className="agent_label">{(parseInt(data?.rating) === 4 || parseInt(data?.rating) === 5) && <p className="signature">Signature</p>}</div>}</div>
                                                                            </div>
                                                                            {data?.agency && data?.agency?.logoPath && (
                                                                                <div className="agency_logo">
                                                                                    <img
                                                                                        src={data?.agency?.logoPath ? imgBaseUrl + data?.agency?.logoPath : developerLogo}
                                                                                        alt={data?.agency?.name}
                                                                                        loading="lazy"
                                                                                        onError={({ currentTarget }) => {
                                                                                            currentTarget.onerror = null;
                                                                                            currentTarget.src = `${developerLogo}`;
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </Link>
                                                                ))}
                                                                <NewCommonPagination currentPage={aPaginations.currentPage} pageSize={aPaginations.pageSize} totalPages={aPaginations.totalPages} tableCallBack={tableCallBackAgent} data={data} queryParams={queryParams} />
                                                            </>
                                                        )
                                                    )}
                                                </div>
                                                <div className="agencies-info-inner-right">
                                                    <div className="agencies-right">
                                                        <h2 className="agencies_title">About</h2>
                                                        {isLoader ? (
                                                            <SpinnerLoader />
                                                        ) : (
                                                            <div className="agencies-property-types">
                                                                {agencyData?.foundedYear && (
                                                                    <div className="agencies-property-details">
                                                                        <div className="list_label_text">
                                                                            {/* <RECalendar /> */}
                                                                            <span>Founded Year :</span>
                                                                            <bdi>{agencyData?.foundedYear}</bdi>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                {agencyData?.propertyTypes && (
                                                                    <div className="agencies-property-details">
                                                                        <div className="list_label_text">
                                                                            {/* <REBuildings /> */}
                                                                            <span>Property Types :</span>
                                                                            <bdi>{agencyData?.propertyTypes}</bdi>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                {agencyData?.serviceAreas && (
                                                                    <div className="agencies-property-details">
                                                                        <div ref={serviceAreasRef} className={`list_label_text${shouldShowButton.serviceAreas ? " desktop_description" : ""}${!isExpanded?.serviceAreas && maxHeight.serviceAreas === "76px" ? " desktop_description_trim" : ""}`} style={{ maxHeight: maxHeight.serviceAreas }}>
                                                                        {/* <RELocation /> */}
                                                                            <span>Service Areas :</span>
                                                                            <bdi>{agencyData?.serviceAreas}</bdi>
                                                                        </div>
                                                                        {shouldShowButton.serviceAreas && (
                                                                            <button onClick={() => toggleExpanded("serviceAreas")} className="readmore-btn">
                                                                                {isExpanded?.serviceAreas ? "Read less" : "Read more"}
                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                )}

                                                                {(agencyData?.agencyStats?.propertySaleCount || agencyData?.agencyStats?.propertyRentCount) && (
                                                                    <div className="agencies-property-details">
                                                                        <div className="list_label_text">
                                                                            {/* <REProperty/> */}
                                                                            <span>Properties :</span>
                                                                            {agencyData?.agencyStats?.propertySaleCount && <bdi>For Sale({agencyData?.agencyStats?.propertySaleCount}) </bdi>}
                                                                            {agencyData?.agencyStats?.propertyRentCount && <bdi>For Rent({agencyData?.agencyStats?.propertyRentCount})</bdi>}
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                {agencyData?.description && (
                                                                    <div className="agencies-property-details">
                                                                        <div ref={descriptionRef} className={`list_label_text${shouldShowButton.description ? " desktop_description" : ""}${!isExpanded?.description && maxHeight.description === "76px" ? " desktop_description_trim" : ""}`} style={{ maxHeight: maxHeight.description }}>
                                                                            {/* <REInfo /> */}
                                                                            <span>Description :</span>
                                                                            <bdi>{agencyData?.description}</bdi>
                                                                        </div>
                                                                        {shouldShowButton.description && (
                                                                            <button onClick={() => toggleExpanded("description")} className="readmore-btn">
                                                                                {isExpanded?.description ? "Read less" : "Read more"}
                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                )}
                                                                {agencyData?.authorities &&
                                                                    agencyData?.authorities.length > 0 &&
                                                                    auth &&
                                                                    auth.map((item, i) => (
                                                                        <div className="agencies-property-details" key={i}>
                                                                            <div className="list_label_text">
                                                                                <span>
                                                                                    <bdi className="text-uppercase">{item.authorityType}</bdi>
                                                                                    {item?.tooltip && (
                                                                                        <span className="wrapper" ref={wrapperRef} onMouseEnter={updatePosition}>
                                                                                            <FiInfo />
                                                                                            <span ref={tooltipRef} className={`tooltip ${position}`}>
                                                                                                {item?.tooltip}
                                                                                            </span>
                                                                                        </span>
                                                                                    )}
                                                                                    :
                                                                                </span>
                                                                                <bdi>{item?.authorityNumber}</bdi>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                {agencyData?.dedNumber && (
                                                                    <div className="agencies-property-details">
                                                                        <div className="list_label_text">
                                                                            <span>
                                                                                DED
                                                                                <span className="wrapper">
                                                                                    <FiInfo />
                                                                                    <span className="tooltip">The licence number issued by the Department of Economic Development</span>
                                                                                </span>
                                                                                :
                                                                            </span>
                                                                            <bdi>{agencyData?.dedNumber}</bdi>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                {agencyData?.reraNumber && (
                                                                    <div className="agencies-property-details">
                                                                        <div className="list_label_text">
                                                                            <span>
                                                                                RERA
                                                                                <span className="wrapper">
                                                                                    <FiInfo />
                                                                                    <span className="tooltip">Licence issued by Dubai's Real Estate Regulatory Agency.</span>
                                                                                </span>
                                                                                :
                                                                            </span>
                                                                            <bdi>{agencyData?.reraNumber}</bdi>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                {agencyData?.ornNumber && (
                                                                    <div className="agencies-property-details">
                                                                        <div className="list_label_text">
                                                                            <span>
                                                                                ORN
                                                                                <span className="wrapper">
                                                                                    <FiInfo />
                                                                                    <span className="tooltip">The Office Registration Number for each RERA-registered real estate company in Dubai</span>
                                                                                </span>
                                                                                :
                                                                            </span>
                                                                            <bdi>{agencyData?.ornNumber}</bdi>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                {agencyData?.admNumber && (
                                                                    <div>
                                                                        <div className="list_label_text">
                                                                            <span>
                                                                                ADM
                                                                                <span className="wrapper">
                                                                                    <FiInfo />
                                                                                    <span className="tooltip">This is the agent license number issued by the Abu Dhabi Department of Economic Development</span>
                                                                                </span>
                                                                                :
                                                                            </span>
                                                                            <bdi>{agencyData?.admNumber}</bdi>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                {agencyData?.address?.full && (
                                                                    <div className="agencies-property-details">
                                                                        <div className="list_label_text">
                                                                            <span>Address :</span>
                                                                            <bdi>{agencyData?.address?.full}</bdi>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {emailModalShow && <EmailAgentModal show={emailModalShow} onHide={handleModalHide} type="agency" title="For inquiries, contact the agency." />}
            {phoneModalShow.show && <AgentContectModal show={phoneModalShow.show} onHide={handlePhoneModalHide} data={phoneModalShow.data} />}
            {agentContectMdl.show && <ContectModal show={agentContectMdl.show} onHide={handleAgentContectMDlHide} data={agentContectMdl.data} />}
            {truAgentShow && <TruAgentModal show={truAgentShow} onHide={handleTruAgentClose} />}
            {qualityShow && <QualityLister show={qualityShow} onHide={handleQualityClose} />}
            {resAgentShow && <ResponsiveBrokerModal show={resAgentShow} onHide={handleResAgentClose} />}
            {socialShare.show && <SocialShareModal type="agencies" data={socialShare} onHide={handleSocialShareClose} />}
        </>
    );
}

export default AgenciesDetails;
